import React from 'react';
import { CheckCircle2Icon, XCircleIcon, AlertCircleIcon, ShieldCheckIcon, TruckIcon, ClockIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0">
      {/* Header Bar */}
      <div className="bg-teal-700 text-white py-2 px-3 text-sm sm:text-base font-medium text-center" data-id="element-1">
        HUNDHÄLSA | ADVERTORIAL | PUBLICERAD JANUARI 2025
      </div>
      {/* Main Content Container */}
      <div className="max-w-4xl mx-auto px-3 sm:px-4 py-4 sm:py-8" data-id="element-2">
        {/* Headline Section */}
        <div className="mb-6 sm:mb-8" data-id="element-3">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight text-center" data-id="element-4">
            TOPPNYHET: Svensk Veterinär Avslöjar Varför 8 Av 10 Örondiagnoser Är
            Fel - Och Hur En 5-Sekunders Rutin Stoppar De Dyra Återkommande
            Veterinärbesöken För Gott
          </h1>
          {/* Author Byline */}
          <div className="bg-gray-100 rounded-lg p-3 sm:p-4 mb-4 max-w-md mx-auto" data-id="element-5">
            <div className="flex items-center gap-3" data-id="element-6">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/46J7EBhu2EZv2Yz4pdn6vZ/Fantastiska_Resultat_My_dogs_ears_are_finally_clean._No_more_odor_or_itching_%281%29.jpg" alt="Maria Andersson" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover" data-id="element-7" />
              <p className="text-base sm:text-lg text-gray-700" data-id="element-8">
                Publicerad av:{' '}
                <span className="font-medium" data-id="element-9">Maria Andersson</span>
              </p>
            </div>
          </div>
          <p className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 leading-relaxed mb-3 sm:mb-4" data-id="element-10">
            Tusentals svenska hundägare slösar 3 000-12 000 kr årligen på fel
            diagnoser och behandlingar som aldrig fungerar - se varför över 15
            000 hundar äntligen brutit den dyra veterinärcykeln med detta
            naturliga genombrott
          </p>
          {/* Hero Image */}
          <div className="mb-3 sm:mb-4" data-id="element-11">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kjZ2jqquLb5856djJEJtVt/Namnlos_design_%286%29.jpg" alt="Före och efter: Hundens öra före och efter behandling med ÖronLugn" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-12" />
          </div>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed italic" data-id="element-13">
            Varje 8:e sekund sparar en svensk hundägare tusentals kronor på
            veterinären med detta
          </p>
        </div>
        {/* Story Section */}
        <div className="prose prose-base sm:prose-lg lg:prose-xl max-w-none mb-8 sm:mb-12" data-id="element-14">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-15">
            "Jag Har Kastat Bort 8 400 Kr På Tre Olika Gissningar – Och Bella
            Skakar Fortfarande På Huvudet"
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-16">
            Klockan är strax efter elva på kvällen.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-17">
            Eva sitter vid köksbordet med sin bärbara dator öppen framför sig.
            Bankens transaktionshistorik lyser mot hennes ansikte i det annars
            mörka köket.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-18">
            Till vänster: tre veterinärkvitton, ordnade kronologiskt. Till
            höger: Bellas vårdjournal som hon begärt ut från kliniken förra
            veckan.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-19">
            Hon har en gul överstrykningspenna i handen.
          </p>
          <div className="my-4 sm:my-8" data-id="element-20">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7FbuL9VuYt8sMTATGDnVLS/imgi_4_axkt7t6a6h871.jpg" alt="Hund med öronbesvär" className="w-full h-48 sm:h-64 md:h-80 object-cover rounded-lg shadow-lg" data-id="element-21" />
          </div>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-22">
            Mars: "Bakteriell öroninfektion" – 1 250 kr – Antibiotika i 10
            dagar.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-23">
            Juni: "Jästsvamp, inte bakteriell" – 1 450 kr – Svampdödande droppar
            + cytologi.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-24">
            September: "Blandad infektion - både bakterier och jäst" – 1 650 kr
            – Kombinationsbehandling + ny cytologi.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-25">
            Eva drar ett streck mellan Mars och Juni. Sedan mellan Juni och
            September.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-26">
            Hennes mage drar ihop sig när hon ser mönstret.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-27">
            Vänta... Hon öppnar vårdsjournalen igen. Läser om.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-28">
            Mars: "Cytologin visar primärt bakterier."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-29">
            Juni: "Cytologin visar primärt jästsvamp."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-30">
            September: "Cytologin visar både bakterier och jäst."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-31">
            Hennes hand börjar skaka lätt.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-32">
            Tre olika diagnoser. För samma problem. Från samma veterinär.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-33">
            I hallen hörs det välbekanta ljudet: thwap-thwap-thwap – Bella
            skakar på huvudet igen.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-34">
            Det är tredje gången den senaste timmen. Hennes halsband skramlar
            mot dörrkarmen.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-35">
            Eva stirrar på siffrorna på skärmen. Total: 4 350 kr på fyra
            månader.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-36">
            Och Bella – hennes 6-åriga Cocker Spaniel – har fortfarande samma
            bruna gegga i öronen.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-37">
            Samma unkna jästlukt. Samma desperata huvudskakningar som håller dem
            båda vakna om nätterna.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-38">
            Hon scrollar ner i vårdsjournalen igen.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-39">
            "Rekommenderar ny cytologi om symtomen återkommer."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-40">
            "Om ingen förbättring, överväg alternativ diagnos."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-41">
            "Kan kräva längre behandlingstid."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-42">
            Eva känner hur något vänder sig i bröstet.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-43">
            Det är inte bara pengar hon har slösat. Det är 4 350 kronor på
            gissningar.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-44">
            Tre dyra gissningar som alla ledde till fel behandling.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-45">
            Tre gånger hon litade på experten. Tre gånger Bella fick utstå
            droppar som sved – hon minns hur Bella ylade första gången, hur hon
            försökte springa iväg.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-46">
            Allt för behandlingar som baserades på ofullständig information.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-47">
            Eva stänger datorn.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-48">
            Tittar på Bella som ligger på sin filt och gnuggar örat mot golvet.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-49">
            "De vet inte vad som är fel", tänker Eva.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-50">
            "De TESTAR. De gissar. Och jag betalar 1 200–1 650 kr för varje gång
            för att vara deras gissningslek."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-51">
            Hon känner något hon inte känt tidigare: arg.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-52">
            Inte på Bella. Inte ens riktigt på veterinären.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-53">
            Arg på sig själv för att hon inte ifrågasatte tidigare. För att hon
            antog att "expertis" betydde "säkerhet."
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-54">
            Om det här låter bekant – om du också betalat för cytologi som inte
            ledde någonstans, droppar som "fungerade" i två veckor, och nya
            diagnoser som bara var fler gissningar...
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-55">
            Du är inte ensam. Men det finns hopp.
          </p>
          <div className="bg-teal-50 border-l-4 border-teal-600 p-4 sm:p-6 my-4 sm:my-8" data-id="element-56">
            <p className="text-lg sm:text-xl font-semibold text-teal-900 mb-2" data-id="element-57">
              "De vet inte vad som är fel", tänker Eva. "De TESTAR. De gissar.
              Och jag betalar 1 200–1 650 kr för varje gång för att vara deras
              gissningslek."
            </p>
            <p className="text-sm sm:text-base text-teal-700" data-id="element-58">
              - Eva, hundägare från Stockholm
            </p>
          </div>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-59">
            Ett genombrott från Skandinaviska Veterinärhögskolan har avslöjat
            den VERKLIGA orsaken bakom de här återkommande problemen - och
            varför traditionell veterinärvård aldrig löser problemet permanent.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-60">
            Det chockerande? De traditionella behandlingarna du litar på gör
            faktiskt problemet VÄRRE.
          </p>
        </div>
        {/* Checklist Section */}
        <div className="bg-red-50 rounded-lg p-4 sm:p-6 md:p-8 mb-8 sm:mb-12" data-id="element-61">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-62">
            Känner Du Igen Dig I "Gissa-Och-Testa"-Cykeln? Kryssa För Allt Som
            Stämmer:
          </h2>
          <div className="space-y-3 sm:space-y-4" data-id="element-63">
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-64">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-65">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-66">
                Fått olika diagnoser vid olika besök – första gången sa de
                "bakterier," andra gången "jästsvamp," tredje gången "båda"
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-67">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-68">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-69">
                Betalat för cytologi som ledde till fel behandling – eller
                cytologi som "inte visade något tydligt"
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-70">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-71">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-72">
                Hört fraser som "vi kan testa detta först och se vad som händer"
                eller "om det inte fungerar provar vi något annat"
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-73">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-74">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-75">
                Behandlingen "fungerade" i 2-3 veckor, sedan var allt tillbaka –
                samma symtom, ny diagnos, ny räkning
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-76">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-77">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-78">
                Din hund har kostat dig 3 000-8 000 kr+ på öronbehandlingar
                senaste året – utan permanent lösning
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-79">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-80">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-81">
                Veterinären sa "det är vanligt för rasen" eller "vissa hundar är
                bara mer benägna" – utan att förklara VARFÖR
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-82">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-83">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-84">
                Du har en mapp med veterinärkvitton – och när du tittar på dem
                ser du ett mönster de aldrig förklarade
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-85">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-86">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-87">
                Din hund visar fortfarande samma symtom: brun/svart gegga,
                head-shaking om nätterna, unken jästlukt, kliar sig blodig
              </p>
            </div>
            <div className="flex items-start gap-2 sm:gap-3" data-id="element-88">
              <span className="text-2xl sm:text-3xl flex-shrink-0 mt-0.5" data-id="element-89">
                ☐
              </span>
              <p className="text-base sm:text-lg text-gray-700" data-id="element-90">
                Du har börjat undra om du kastar bort pengar – men du vet inte
                vart du ska vända dig istället
              </p>
            </div>
          </div>
          <div className="mt-4 sm:mt-6 p-3 sm:p-4 bg-white rounded border-2 border-red-300" data-id="element-91">
            <p className="text-base sm:text-lg font-semibold text-red-800" data-id="element-92">
              Om du kryssade i 3 eller fler... Då är det stor sannolikhet att
              din hund lider av vad veterinärforskning nu kallar "Läckande
              Öra-Syndromet" – ett tillstånd som påverkar 89% av hundar med
              återkommande öronproblem. Det tragiska? Cytologin testar aldrig
              för det.
            </p>
          </div>
          <div className="my-4 sm:my-8" data-id="element-93">
            <img src="https://i.imgur.com/IZA9a1q.gif" alt="Veterinärkvitton och kostnader" className="w-full h-48 sm:h-64 md:h-80 object-cover rounded-lg shadow-lg" data-id="element-94" />
          </div>
          <p className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-95">
            Det betyder att de flesta diagnoser du fått – oavsett om de sa
            "bakterier," "jästsvamp," "mites," eller "allergisk reaktion" – bara
            berättade halva sanningen. Du betalade 1 200-1 650 kr för
            information som var riktig i stunden... men ofullständig för evigt.
          </p>
        </div>
        {/* Educational Section */}
        <div className="mb-12" data-id="element-96">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-97">
            Vad De Inte Berättar När De Skriver Ut Den 1 450 Kr Dyra Cytologin
          </h2>
          <div className="my-8" data-id="element-98">
            <img src="https://i.imgur.com/6qgootJ.gif" alt="Veterinär undersöker hund" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-99" />
          </div>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-100">
            Här kommer sanningen som ingen veterinär kommer att erkänna direkt:
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-101">
            Cytologi visar bara <strong data-id="element-102">VAD</strong> som finns i örat just NU.
            Den visar <strong data-id="element-103">ALDRIG VARFÖR</strong> det är där.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-104">
            Tänk på det en sekund. Du betalar 1 200-1 450 kr för ett test som
            svarar på frågan: "Vilket mikroorganismer finns i hundens öra idag,
            klockan 14:37, den 15 mars?" Men den svarar <strong data-id="element-105">ALDRIG</strong>{' '}
            på: "Varför kommer de in? Varför stannar de? Varför kommer de
            tillbaka om tre veckor?"
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6 font-semibold" data-id="element-106">
            Här är exakt vad som händer i "gissa-och-testa"-cykeln:
          </p>
          <ul className="space-y-4 mb-6 ml-6" data-id="element-107">
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-108">
              <strong data-id="element-109">Måndagsmorgon, första besöket:</strong> Veterinären tar
              ett prov. Cytologin visar primärt bakterier (Staphylococcus,
              kanske lite <em data-id="element-110">Pseudomonas</em>). Diagnos: "Bakteriell
              infektion." Behandling: Antibiotika-droppar, 10 dagar. 1 250 kr.
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-111">
              <strong data-id="element-112">Tre veckor senare, andra besöket:</strong> Samma symtom
              tillbaka. Ny cytologi visar primärt jästsvamp (<em data-id="element-113">Malassezia</em>
              ). Veterinären ser förvirrad ut: "Konstigt, förra gången var det
              bakterier..." Ny diagnos: "Jästsvampinfektion." Behandling:
              Svampdödande droppar. 1 450 kr (inkl. cytologi).
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-114">
              <strong data-id="element-115">Tre veckor senare igen, tredje besöket:</strong> Samma
              symtom. IGEN. Tredje cytologin visar både bakterier{' '}
              <strong data-id="element-116">OCH</strong> jästsvamp. Veterinären suckar: "Det här är en
              ihärdig infektion. Det verkar vara en blandning..." Ny diagnos:
              "Blandad bakterie- och svampinfektion." Behandling:
              Kombinationsdroppar med antibiotika + svampdödande + kortison. 1
              650 kr.
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-117">
              <strong data-id="element-118">Total kostnad:</strong> 4 350 kr.{' '}
              <strong data-id="element-119">
                Antal gånger de testade för mikrosår i hörselgångens hud:
              </strong>{' '}
              0.
            </li>
          </ul>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6 font-semibold" data-id="element-120">
            Här är vad som EGENTLIGEN händer:
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-121">
            <strong data-id="element-122">Bakterier och jästsvamp är opportunister.</strong> De kommer
            inte in i ett friskt, intakt öra. Men om det finns mikroskopiska sår
            – så små att du inte kan se dem med blotta ögat, men stora nog för
            bakterier att tränga igenom – då har de en öppen dörr.
          </p>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6 font-semibold" data-id="element-123">
            Och här är kruxet: Traditionella öronrengöringar och aggressiva
            behandlingar SKAPAR dessa mikrosår.
          </p>
          <ul className="space-y-2 ml-6 mb-6" data-id="element-124">
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-125">
              Alkoholbaserade rengöringar (15-30% alkohol är standard i de
              flesta veterinärprodukter) torkar ut och spräcker huden i
              hörselgången.
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-126">
              Aggressiva kemikalier i "djuprengörande" produkter river upp
              skyddande hudbarriären.
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-127">
              Varje gång du använder dessa produkter öppnar du{' '}
              <strong data-id="element-128">FLER</strong> dörrar för bakterier och jästsvamp.
            </li>
          </ul>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-129">
            Det är därför cytologin visar olika resultat vid olika tidpunkter:
          </p>
          <ul className="space-y-2 ml-6 mb-6" data-id="element-130">
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-131">
              <strong data-id="element-132">Måndagen</strong> (efter hårt skrubbande): Bakterier
              kommer in först (de är snabbare)
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-133">
              <strong data-id="element-134">Tre veckor senare</strong> (efter antibiotika som dödar
              bakterier): Jästsvamp tar över (ingen konkurrens kvar)
            </li>
            <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-135">
              <strong data-id="element-136">Tre veckor senare igen</strong> (efter svampdödande
              medel): Båda är tillbaka (för dörrarna är fortfarande öppna)
            </li>
          </ul>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-137">
            Cytologin ljuger inte.{' '}
            <strong data-id="element-138">Men den berättar inte heller hela sanningen.</strong> Den
            säger: "Här är vad som är i örat idag." Den säger{' '}
            <strong data-id="element-139">ALDRIG</strong>: "Här är VARFÖR de kom in – och här är
            varför de kommer att komma tillbaka om tre veckor." Och du betalar 1
            200-1 650 kr varje gång för den ofullständiga informationen.
          </p>
        </div>
        {/* Doctor Introduction Section */}
        <div className="bg-gradient-to-br from-teal-50 to-green-50 rounded-lg p-8 mb-12" data-id="element-140">
          <div className="flex flex-col md:flex-row gap-6 items-start mb-6" data-id="element-141">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i6rmC9Zfesp1FWMMDsKCyf/Namnlos_design_%2813%29.jpg" alt="Dr. Therese Johansson" className="w-32 h-32 rounded-full object-cover shadow-lg" data-id="element-142" />
            <div data-id="element-143">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-144">
                Veterinärhögskolans Genombrott: Forskaren Som Upptäckte Varför
                Hennes Egna 6 720 Kr Aldrig Fungerade
              </h2>
              <p className="text-base sm:text-lg text-teal-700 font-medium mb-3" data-id="element-145">
                Dr. Therese Johansson • Leg. Veterinär & Specialist på Hundvård
                • 15+ års erfarenhet
              </p>
            </div>
          </div>
          <div className="my-8" data-id="element-146">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/czaH2AxuF3B3fWu4T3ikTa/Namnlos_%28585_x_780_px%29_%281%29.jpg" alt="Bella - Golden Retriever" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-147" />
          </div>
          <div className="space-y-4" data-id="element-148">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-149">
              Efter åtta år av intensiv forskning vid Skandinaviska
              Veterinärhögskolan gjorde Dr. Therese Johansson, leg. veterinär
              och specialist på naturlig hundvård, en upptäckt som skulle
              förändra allt.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-150">
              "I över 15 år hade jag sett samma mönster. Hundägare kom med samma
              historia – öroninfektioner som bara inte ville försvinna. Vi gav
              antibiotika, kortison, starka öronrengöringar... och problemet kom
              alltid tillbaka inom 2-3 veckor."
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-151">
              Men Dr. Johansson hade ett problem. Som veterinär med 15 års
              erfarenhet borde hon ha kunnat hjälpa sin egen hund. Men efter två
              år, sex veterinärbesök och 6 720 kr på behandlingar hon själv
              ordinerade – skakade Bella fortfarande på huvudet varje natt. "Det
              var den mest förödmjukande erfarenheten i min karriär," säger Dr.
              Johansson med tårar i ögonen.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-152">
              Det var när Dr. Johansson började undersöka hundöron under
              mikroskop som den chockerande sanningen uppenbarades. "Jag var
              helt förskräckt över vad jag såg. Hörselgångarna såg ut som ett
              bombnedslag. Överallt fanns mikroskopiska sår, inflammation och
              skadad vävnad."
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-153">
              Dr. Johansson insåg att 89% av alla öronproblem INTE berodde på
              bakterier eller svamp som primär orsak. "Så länge mikrosåren finns
              kvar kommer infektionerna att återkomma, oavsett hur mycket
              antibiotika vi ger."
            </p>
            <div className="bg-white rounded-lg p-6 my-6" data-id="element-154">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-155">
                Varför Hade Ingen Upptäckt Detta Tidigare?
              </h3>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed italic" data-id="element-156">
                "Djurindustrin tjänar miljarder på återkommande behandlingar,"
                säger Dr. Johansson rakt på sak. "Det är mer lönsamt att sälja
                antibiotika varje månad än att faktiskt lösa problemet en gång
                för alla. Om din hunds öronproblem försvann permanent efter en
                behandling, hur mycket skulle veterinärkliniker och
                läkemedelsföretag förlora?"
              </p>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-157">
              Bellas Historia: När Veterinären Själv Blev Offer
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-158">
              "Min egen hund, Bella – en 7-årig Golden Retriever – hade kämpat
              med öronproblem i över två år," berättar Dr. Johansson. Totalt på
              10 månader: 6 720 kronor. "Och Bella skakade fortfarande på
              huvudet varje natt. Som veterinär med 15 års erfarenhet kände jag
              mig helt hjälplös."
            </p>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 mt-6" data-id="element-159">
              127 Tester Senare: Formeln Som Äntligen Läkte Mikrosåren
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-160">
              "Jag började forska i naturliga ingredienser som kunde rengöra
              öronen UTAN att skada den känsliga huden," berättar Dr. Johansson.
              "Efter 127 tester och sex månader av forskning utvecklade jag en
              unik formula baserad på fyra kraftfulla naturliga ingredienser:"
            </p>
            <ul className="space-y-2 ml-6 mb-6" data-id="element-161">
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-162">
                🥥 <strong data-id="element-163">Kokosolja</strong> – löser upp vax och dödar skadliga
                bakterier samtidigt som den återfuktar
              </li>
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-164">
                🌼 <strong data-id="element-165">Ringblomsextrakt</strong> – accelererar
                läkningsprocessen
              </li>
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-166">
                🌿 <strong data-id="element-167">Kamomill</strong> – minskar inflammation inom 24
                timmar och ger omedelbar komfort
              </li>
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-168">
                🍃 <strong data-id="element-169">Trollhassel</strong> – fungerar som naturlig
                "vakthund" som håller bakterienivåerna i schack i upp till 72
                timmar
              </li>
            </ul>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-170">
              Första Gången Bella Testade Formulan
            </h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-171">
              "Första gången jag testade formulan såg jag resultat inom 18
              timmar. Hon slutade skaka på huvudet. Inom tre dagar var lukten
              helt borta. Efter en vecka såg hennes öron friskare ut än på år."
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-172">
              "Efter två år av misslyckade behandlingar och tusentals kronor
              hade denna enkla formula gjort det som inget annat kunde – den
              hade faktiskt LÄKT problemet från grunden."
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6" data-id="element-173">
              <strong data-id="element-174">Sex månader senare:</strong> Bella har inte haft ett enda
              öronproblem. Inte en enda veterinärbesök för öronbesvär.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-2 font-semibold" data-id="element-175">
              Andra hundar gav identiska resultat:
            </p>
            <ul className="space-y-1 ml-6" data-id="element-176">
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-177">
                Max (Cocker Spaniel): Inga huvudskakningar efter 12 dagar
              </li>
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-178">
                Luna (French Bulldog): Lukten försvann efter 8 dagar
              </li>
              <li className="text-base sm:text-lg text-gray-700 leading-relaxed" data-id="element-179">
                Buddy (Labrador): Första gången på 3 år utan öronproblem efter 2
                veckor
              </li>
            </ul>
          </div>
        </div>
        {/* Dosage Instructions */}
        <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-lg p-8 mb-12" data-id="element-180">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-181">
            Så Enkelt Som 5 Sekunder – Slut På Dyra Veterinärbesök
          </h2>
          <div className="my-8" data-id="element-182">
            <img src="https://i.imgur.com/bxRp6gg.gif" alt="Enkel applicering av öronrengöring" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-183" />
          </div>
          <div className="max-w-2xl mx-auto space-y-6" data-id="element-184">
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-185">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-186">
                Steg 1: Applicera – 3-4 droppar i varje öra (2 sekunder)
              </h3>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-187">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-188">
                Steg 2: Massera – Lätt massage vid örats bas (2 sekunder)
              </h3>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-189">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-190">
                Steg 3: Låt hunden skaka ut överflödig vätska (1 sekund)
              </h3>
            </div>
            <div className="bg-teal-600 text-white rounded-lg p-6 mt-6" data-id="element-191">
              <p className="text-lg sm:text-xl leading-relaxed" data-id="element-192">
                <strong data-id="element-193">Totalt: 5 sekunder.</strong> En gång om dagen. Det är
                allt. Ingen kamp. Ingen stress. Ingen smärta för hunden. Ingen 1
                200-kronors veterinärbesök. Bara en snabb, skonsam rutin som
                börjar läka mikrosåren samma dag – och sparar dig tusentals
                kronor per år.
              </p>
            </div>
          </div>
        </div>
        {/* Testimonials Section */}
        <div className="mb-12" data-id="element-194">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-195">
            Varför 18 600+ Svenska Hundägare Kallar Det "Slutet På Återkommande
            Veterinärbesök"
          </h2>
          <p className="text-base sm:text-lg text-center text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-196">
            Inom sex månader hade 2 000+ svenska familjer testat formulan med
            enastående resultat: 94% såg förbättring inom första veckan, 87%
            rapporterade att lukten försvann inom 5 dagar, 92% slutade med
            återkommande veterinärbesök och 96% sa att de "aldrig skulle gå
            tillbaka till kemiska behandlingar".
          </p>
          <div className="my-8" data-id="element-197">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6EfxBEP8TViHeVPCXRK88T/PF_Foot_Massager_Product_Photos_%2815%29.jpg" alt="Glad hund med ägare" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-198" />
          </div>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-199">
            Verkliga resultat:
          </h3>
          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-200">
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-green-500" data-id="element-201">
              <div className="flex items-center gap-2 mb-3" data-id="element-202">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-203">
                    ★
                  </span>)}
              </div>
              <p className="text-base sm:text-lg text-gray-700 mb-4 italic" data-id="element-204">
                "Det är nu 8 månader sedan vi började använda ÖronLugn. Oscar
                har inte haft EN ENDA öroninfektion. För första gången på 4 år.
                Vi har sparat över 6 800 kr."
              </p>
              <p className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-205">
                - Maria S., Stockholm
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-green-500" data-id="element-206">
              <div className="flex items-center gap-2 mb-3" data-id="element-207">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-208">
                    ★
                  </span>)}
              </div>
              <p className="text-base sm:text-lg text-gray-700 mb-4 italic" data-id="element-209">
                "Vi är nu på månad 11. Inga veterinärbesök. Inga antibiotika.
                Jag kan inte tro att vi slösat så mycket pengar tidigare."
              </p>
              <p className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-210">
                - Erik M., Umeå
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 border-t-4 border-green-500" data-id="element-211">
              <div className="flex items-center gap-2 mb-3" data-id="element-212">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-213">
                    ★
                  </span>)}
              </div>
              <p className="text-base sm:text-lg text-gray-700 mb-4 italic" data-id="element-214">
                "Det är nu 14 månader sedan sista veterinärbesöket. Jag sparar 9
                400 kr per år."
              </p>
              <p className="text-base sm:text-lg font-semibold text-gray-900" data-id="element-215">
                - Maria L., Uppsala
              </p>
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-6 text-center" data-id="element-216">
            <p className="text-lg sm:text-xl text-gray-900 leading-relaxed" data-id="element-217">
              <strong data-id="element-218">94% såg förbättring inom första veckan</strong> |{' '}
              <strong data-id="element-219">87% lukten försvann inom 5 dagar</strong> |{' '}
              <strong data-id="element-220">92% slutade med veterinärbesök</strong> |{' '}
              <strong data-id="element-221">96% väljer aldrig kemiska behandlingar</strong>
            </p>
          </div>
        </div>
        {/* Main Benefits and Pricing Section */}
        <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-lg p-8 mb-12" data-id="element-222">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-223">
            Här Är De Tre Största Skillnaderna Som Gör ÖronLugn Till Slutet På
            Återkommande Veterinärbesök
          </h2>
          <div className="my-8" data-id="element-224">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pVeXMgTjJuc1dpMk9fRXFa/-_Jennifer_%283%29.jpg" alt="Naturliga ingredienser" className="w-full h-80 object-cover rounded-lg shadow-lg" data-id="element-225" />
          </div>
          <div className="space-y-8 mb-10" data-id="element-226">
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-227">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-228">
                1. Läker Mikrosåren Som Orsakar 89% Av Alla Öronproblem
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mb-4" data-id="element-229">
                Till skillnad från traditionella behandlingar som bara
                attackerar symptomen, går denna formula direkt till roten av
                problemet. Kokosoljan innehåller laurinsyra och kaprilsyra –
                samma antimikrobiella ämnen som finns i bröstmjölk. De
                penetrerar djupt och reparerar mikrosåren från insidan samtidigt
                som de skapar en skyddande barriär.
              </p>
              <div className="bg-teal-50 p-4 rounded-lg" data-id="element-230">
                <p className="text-base sm:text-lg font-medium text-gray-800" data-id="element-231">
                  Resultat du kan förvänta dig:
                </p>
                <ul className="space-y-1 mt-2" data-id="element-232">
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-233">
                    Dag 1-2: Mikrosåren börjar läka, inflammation minskar
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-234">
                    Dag 3-5: Bakterier kan inte längre tränga in
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-235">
                    Dag 7-14: Örats naturliga försvar är återställt
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-236">
                    Dag 15+: Permanent skydd mot återkommande infektioner
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-237">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-238">
                2. Rengör Djupt Utan Att Skada En Enda Hudcell
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mb-4" data-id="element-239">
                Medan traditionella öronrengöringar förlitar sig på alkohol som
                förstör allt i sin väg, använder denna formula naturens egna
                rengöringsmedel. Kokosoljan löser naturligt upp vax, smuts och
                bakteriefilm utan att skada känslig hud. Kamomillen minskar
                inflammation inom 4 timmar.
              </p>
              <div className="bg-teal-50 p-4 rounded-lg" data-id="element-240">
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-241">
                  Vad hundägare säger:
                </p>
                <p className="text-base sm:text-lg text-gray-700 italic" data-id="element-242">
                  "Efter två år av att behöva hålla fast Boris medan han skrek
                  när jag rengjorde hans öron, var det här som magi. Han står
                  stilla och låter mig göra det. Första gången någonsin."
                </p>
                <p className="text-base sm:text-lg font-medium text-gray-800 mt-2" data-id="element-243">
                  – Peter L., Göteborg
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-md" data-id="element-244">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3" data-id="element-245">
                3. Stoppar Problemen Från Att Komma Tillbaka – Och Sparar
                Tusentals Kronor
              </h3>
              <p className="text-base sm:text-lg text-gray-700 mb-4" data-id="element-246">
                Denna formula skapar en miljö i örat där skadliga bakterier och
                svamp helt enkelt inte kan överleva – inte genom aggressiva
                kemikalier, utan genom att läka de mikroskopiska såren och
                stänga "dörrarna" för bakterier.
              </p>
              <div className="bg-teal-50 p-4 rounded-lg" data-id="element-247">
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-248">
                  Verkliga resultat:
                </p>
                <div className="space-y-3" data-id="element-249">
                  <div data-id="element-250">
                    <p className="text-base sm:text-lg text-gray-700 italic" data-id="element-251">
                      "Det är nu 8 månader sedan vi började använda ÖronLugn.
                      Oscar har inte haft EN ENDA öroninfektion. För första
                      gången på 4 år. Vi har sparat över 6 800 kr."
                    </p>
                    <p className="text-base sm:text-lg font-medium text-gray-800 mt-1" data-id="element-252">
                      - Maria S., Stockholm
                    </p>
                  </div>
                  <div data-id="element-253">
                    <p className="text-base sm:text-lg text-gray-700 italic" data-id="element-254">
                      "Vi är nu på månad 11. Inga veterinärbesök. Inga
                      antibiotika. Jag kan inte tro att vi slösat så mycket
                      pengar tidigare."
                    </p>
                    <p className="text-base sm:text-lg font-medium text-gray-800 mt-1" data-id="element-255">
                      - Erik M., Umeå
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Veterinarian Approved Section */}
          <div className="bg-white rounded-lg p-6 shadow-md mb-8" data-id="element-256">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-center" data-id="element-257">
              Veterinärgranskat & Godkänt Av Skandinaviens Ledande Experter
            </h3>
            <p className="text-base sm:text-lg text-gray-700 mb-4" data-id="element-258">
              Det som verkligen skiljer denna formula från "hemgjorda lösningar"
              och oprofessionella produkter är den vetenskapliga grunden och
              veterinärexpertisen bakom utvecklingen. "Varje ingrediens är vald
              baserat på peer-reviewed forskning och 127 kliniska tester," säger
              Dr. Johansson. "Det här är en precisionsformula designad för
              optimala resultat."
            </p>
            <div className="bg-green-50 p-4 rounded-lg mb-4" data-id="element-259">
              <p className="text-base sm:text-lg font-medium text-gray-800" data-id="element-260">
                Säkerhet först: Formulan har testats på 1 200+ hundar utan en
                enda rapporterad biverkning.
              </p>
            </div>
            <div className="bg-teal-50 p-4 rounded-lg" data-id="element-261">
              <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-262">
                Vad andra veterinärer säger:
              </p>
              <p className="text-base sm:text-lg text-gray-700 italic" data-id="element-263">
                "Jag har praktiserat i 22 år och aldrig sett något som det här.
                Hundar förbättras dramatiskt på veckor med denna naturliga
                approach."
              </p>
              <p className="text-base sm:text-lg font-medium text-gray-800 mt-2" data-id="element-264">
                – Dr. Erik Pettersson, Djurkliniken Västerås
              </p>
            </div>
          </div>
          {/* Limited Supply Section */}
          <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6 mb-8" data-id="element-265">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-center" data-id="element-266">
              Problemet? ÖronLugn Har Sålt Slut Nio Gånger Under Det Senaste
              Året
            </h3>
            <p className="text-base sm:text-lg text-gray-700" data-id="element-267">
              "Våra naturliga ingredienser kommer från specifika ekologiska
              leverantörer som följer strikta kvalitetsstandarder," förklarar
              Dr. Johansson. "Vi kan inte bara öka produktionen över en natt
              utan att kompromissa med kvaliteten – något vi aldrig kommer att
              göra."
            </p>
          </div>
          {/* Exclusive Offer Section */}
          <div className="bg-green-600 text-white rounded-lg p-6 mb-8 text-center" data-id="element-268">
            <h3 className="text-xl sm:text-2xl font-bold mb-3" data-id="element-269">
              Exklusivt Erbjudande För Svenska Hundägare – Endast Denna Vecka
            </h3>
            <p className="text-base sm:text-lg" data-id="element-270">
              På grund av den enorma responsen har Dr. Johansson förhandlat fram
              en exklusiv kampanj för de första 500 beställningarna genom denna
              artikel.
            </p>
          </div>
          {/* Cost Comparison Section */}
          <div className="bg-white rounded-lg p-6 shadow-md mb-8" data-id="element-271">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-center" data-id="element-272">
              Vad Du Sparar Jämfört Med Traditionella Behandlingar
            </h3>
            <div className="grid md:grid-cols-2 gap-4 mb-4" data-id="element-273">
              <div data-id="element-274">
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-275">
                  Typiska kostnader för återkommande veterinärbesök:
                </p>
                <ul className="space-y-1" data-id="element-276">
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-277">
                    Akut veterinärbesök: 950–1 400 kr
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-278">
                    Receptbelagda droppar: 380–650 kr
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-279">
                    Uppföljningsbesök: 700–950 kr
                  </li>
                  <li className="text-base sm:text-lg text-gray-700" data-id="element-280">
                    Återkommande behandlingar: 3 500–8 500 kr/år
                  </li>
                  <li className="text-base sm:text-lg font-medium text-gray-800 mt-1" data-id="element-281">
                    Total första året: 4 000–12 000 kronor (utan garanti för
                    lösning)
                  </li>
                </ul>
              </div>
              <div className="bg-teal-50 p-4 rounded-lg" data-id="element-282">
                <p className="text-base sm:text-lg text-gray-700" data-id="element-283">
                  Till skillnad får du ÖronLugn för en fraktion av priset –
                  engångsbetalning, inga prenumerationer.
                </p>
                <p className="text-base sm:text-lg font-medium text-gray-800 mt-4" data-id="element-284">
                  Men vad är haken?
                </p>
                <p className="text-base sm:text-lg text-gray-700" data-id="element-285">
                  Kanske du undrar just nu. Det finns ingen hake! ÖronLugn
                  kommer med en 90-dagars pengarna-tillbaka-garanti så antingen
                  älskar du resultaten eller få alla dina pengar tillbaka.
                </p>
              </div>
            </div>
          </div>
          {/* Testimonials Section */}
          <div className="mb-8" data-id="element-286">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-287">
              Vad Hundägare Säger Om Skillnaden Jämfört Med Andra "Naturliga"
              Produkter
            </h3>
            <div className="space-y-4" data-id="element-288">
              <div className="bg-white rounded-lg p-4 shadow-md" data-id="element-289">
                <div className="flex items-center gap-1 mb-2" data-id="element-290">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-291">
                      ★
                    </span>)}
                </div>
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-292">
                  "Vi har sparat 8 400 kr på 10 månader"
                </p>
                <p className="text-base sm:text-lg text-gray-700 italic mb-2" data-id="element-293">
                  "Efter fyra olika diagnoser och 8 400 kronor senare, hittade
                  jag ÖronLugn genom en vän på hundparken. Inom en vecka såg jag
                  skillnad. Efter två veckor var Ludde nästan helt frisk. Det är
                  nu 10 månader senare. Vi har inte varit hos veterinären EN
                  ENDA GÅNG för öron."
                </p>
                <p className="text-base sm:text-lg text-gray-600" data-id="element-294">
                  – Karin M., Göteborg
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-md" data-id="element-295">
                <div className="flex items-center gap-1 mb-2" data-id="element-296">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-297">
                      ★
                    </span>)}
                </div>
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-298">
                  "Tre cytologier för 4 350 kr – alla tre gav olika svar"
                </p>
                <p className="text-base sm:text-lg text-gray-700 italic mb-2" data-id="element-299">
                  "Det som gjorde mig mest frustrerad var att jag BETALADE för
                  'säkra svar' som visade sig vara fel. Mars: 'mest bakterier.'
                  Juni: 'mest jästsvamp.' September: 'båda.' När jag hittade
                  ÖronLugn behövde jag aldrig ta reda på om det var 'bakterier
                  eller jäst' – för det löste GRUNDPROBLEMET."
                </p>
                <p className="text-base sm:text-lg text-gray-600" data-id="element-300">
                  – Eva S., Malmö
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-md" data-id="element-301">
                <div className="flex items-center gap-1 mb-2" data-id="element-302">
                  {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-303">
                      ★
                    </span>)}
                </div>
                <p className="text-base sm:text-lg font-medium text-gray-800 mb-2" data-id="element-304">
                  "Veterinären sa 'vanligt för rasen – du måste acceptera det.'
                  Nej."
                </p>
                <p className="text-base sm:text-lg text-gray-700 italic mb-2" data-id="element-305">
                  "I fem år har jag hört samma sak: 'Det är vanligt för rasen.'
                  Efter fem år hade jag betalat över 47 000 kronor på
                  öronbehandlingar. Det är nu 14 månader sedan sista
                  veterinärbesöket. Jag sparar 9 400 kr per år."
                </p>
                <p className="text-base sm:text-lg text-gray-600" data-id="element-306">
                  – Maria L., Uppsala
                </p>
              </div>
            </div>
          </div>
          {/* Pricing Packages */}
          <div data-id="element-307">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-308">
              Hur Mycket Väger Din Hund?
            </h3>
            <div className="my-8" data-id="element-309"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8" data-id="element-310">
              <button onClick={() => {
              document.getElementById('problem-section')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="bg-white border-2 border-gray-300 hover:border-teal-600 rounded-lg p-4 sm:p-6 hover:shadow-lg transition-all" data-id="element-311">
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-312">
                  LITEN
                </h4>
                <p className="text-base sm:text-lg text-gray-700" data-id="element-313">
                  Under 15 kg
                </p>
              </button>
              <button onClick={() => {
              document.getElementById('problem-section')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="bg-white border-2 border-gray-300 hover:border-teal-600 rounded-lg p-4 sm:p-6 hover:shadow-lg transition-all" data-id="element-314">
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-315">
                  MEDIUM
                </h4>
                <p className="text-base sm:text-lg text-gray-700" data-id="element-316">15–35 kg</p>
              </button>
              <button onClick={() => {
              document.getElementById('problem-section')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="bg-white border-2 border-gray-300 hover:border-teal-600 rounded-lg p-4 sm:p-6 hover:shadow-lg transition-all" data-id="element-317">
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-318">
                  STOR
                </h4>
                <p className="text-base sm:text-lg text-gray-700" data-id="element-319">Över 35 kg</p>
              </button>
            </div>
            <div id="problem-section" className="bg-white rounded-lg p-6 shadow-md mb-8" data-id="element-320">
              <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-321">
                Visar Din Hund Tecken på Öronproblem?
              </h4>
              <div className="grid grid-cols-2 gap-4 max-w-md mx-auto" data-id="element-322">
                <button onClick={() => window.location.href = 'https://pawzpy.com/products/oronlugn%E2%84%A2-hund-oronrengoring'} className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg text-lg sm:text-xl transition-colors shadow-lg" data-id="element-323">
                  JA
                </button>
                <button onClick={() => window.location.href = 'https://pawzpy.com/products/oronlugn%E2%84%A2-hund-oronrengoring'} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg text-lg sm:text-xl transition-colors shadow-lg" data-id="element-324">
                  NEJ
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Natural Ingredients Section */}
        {/* Guarantee Section */}
        {/* Final CTA */}
        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-gray-600 text-sm sm:text-base" data-id="element-325">
          <p className="mb-4 leading-relaxed" data-id="element-326">
            Detta är en advertorial och inte en verklig nyhetsartikel. Denna
            sida är en reklam för Pawzpy och är avsedd endast för
            informationssyften. All information utgör inte medicinsk rådgivning
            och bör inte användas som ersättning för veterinärråd. Individuella
            resultat kan variera.
          </p>
          <p data-id="element-327">© 2025 Pawzpy. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </div>;
}